import {Injectable, signal} from '@angular/core';
import {TurnkeyCostFile} from "../types/turnkey-cost-file.types";

@Injectable({
  providedIn: 'root'
})
export class TurnkeyCostFilesStateService {
  private _turnkeyCostFilesState = signal<Record<number, Array<TurnkeyCostFile>>>({});
  public turnkeyCostFilesState = this._turnkeyCostFilesState.asReadonly();

  public setTurnkeyCostFilesState(id: number, turnkeyCostFiles: Array<TurnkeyCostFile>): void {
    this._turnkeyCostFilesState.set({
      ...this._turnkeyCostFilesState(),
      [id]: turnkeyCostFiles
    });
  }

  public getTurnkeyCostFilesById(id: number): Array<TurnkeyCostFile> {
    return this.turnkeyCostFilesState()[id];
  }

  public deleteFileById(fileId: number, turnkeyCostId: number): void {
    this._turnkeyCostFilesState.update(state => {
      const currentFiles = state[turnkeyCostId] || [];
      const updatedFiles = currentFiles.filter(file => file.id !== fileId);

      return {
        ...state,
        [turnkeyCostId]: updatedFiles
      };
    });
  }

  public updateTurnkeyCostFilesState(turnkeyCostId: number, turnkeyCostFile: TurnkeyCostFile): void {
    this._turnkeyCostFilesState.update(state => {
      const currentFiles = state[turnkeyCostId] || [];
      const updatedFiles = [ ...currentFiles, turnkeyCostFile ];

      return {
        ...state,
        [turnkeyCostId]: updatedFiles
      };
    });
  }

  public deleteTurnkeyCostFilesState(turnkeyCostId: number): void {
    this._turnkeyCostFilesState.update(state => {
      const newState = { ...state };
      delete newState[turnkeyCostId];
      return newState;
    });
  }
}
